import { wpPages } from '../../content/wpPages.generated';
import { contactDetails, siteIdentity } from '../../content/siteContent';
import { BlockRenderer } from '../components/BlockRenderer';
import { InquiryForm } from '../components/InquiryForm';
import { splitHero, heroStyleFor } from './CuratedPage';

export function ContactPage() {
  const { title, blocks, heroImageId } = wpPages.contact;
  const { lead, rest } = splitHero(blocks);
  const hasDetails = Boolean(contactDetails.email || contactDetails.phone || contactDetails.address);

  return (
    <>
      <header className={`page-hero${heroImageId ? ' page-hero--image' : ''}`} style={heroStyleFor(heroImageId)}>
        <p className="eyebrow">{siteIdentity.name}</p>
        <h1>{title}</h1>
        {lead && <p className="page-hero__lead">{lead.text}</p>}
      </header>

      <div className="contact-grid">
        <section className="prose"><BlockRenderer blocks={rest} /></section>
        {hasDetails && (
          <dl className="contact-card">
            {contactDetails.email && (<>
              <dt>Email</dt><dd><a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a></dd>
            </>)}
            {contactDetails.phone && (<>
              <dt>Phone</dt><dd><a href={contactDetails.phoneHref}>{contactDetails.phone}</a></dd>
            </>)}
            {contactDetails.address && (<>
              <dt>Address</dt><dd>{contactDetails.address}</dd>
            </>)}
          </dl>
        )}
      </div>

      <section className="inquiry-section" aria-label="Contact form">
        <InquiryForm />
      </section>
    </>
  );
}
